module.exports = __webpack_public_path__ + "img/logo.3bab4dea.png";